export default function useThoughtHelpers() {
  function getCurrenThoughtUri(thoughtid: number) {
    return (
      window.location.protocol +
      '//' +
      window.location.hostname +
      (location.port ? ':' + location.port : '') +
      window.location.pathname +
      '#/?thought_id=' +
      thoughtid
    );
  }

  return {
    getCurrenThoughtUri,
  };
}
